export const gregorian_fr = {
    name: "gregorian_fr",
    months: [
        ["Janvier", "Janv"],
        ["Février", "Févr"],
        ["Mars", "Mars"],
        ["Avril", "Avril"],
        ["Mai", "Mai"],
        ["Juin", "Juin"],
        ["Juillet", "Juil"],
        ["Août", "Août"],
        ["Septembre", "Sept"],
        ["Octobre", "Oct"],
        ["Novembre", "Nov"],
        ["Décembre", "Déc"],
    ],
    weekDays: [
        ["Samedi", "Sam"],
        ["Dimanche", "Dim"],
        ["Lundi", "Lun"],
        ["Mardi", "Mar"],
        ["Mercredi", "Mer"],
        ["Jeudi", "Jeu"],
        ["Vendredi", "Ven"],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
        ["AM", "am"],
        ["PM", "pm"],
    ],
};